import GetReferentsByLessonIdRequestModelBase from '../_generated/modelBases/get-referents-by-lesson-id-request-model-base';

export default class GetReferentsByLessonIdRequestModel extends GetReferentsByLessonIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
